jQuery(document).ready(function ($) {
  var tables = $(".box-text table");
  var tables_loaded = [];

  tables.each(function (index, element) {
    $(this).before("<div class='table-responsive'></div>");

    insert_table(element);
  });

  function insert_table(table) {
    $(".table-responsive").each(function (index, element) {
      $(this).prepend(table);
    });
  }
});
